module.exports = __webpack_public_path__ + "static/media/pop-up-0.015a16f7.png";